import React, { Component, Fragment } from "react"
import { compose } from "recompose"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/styles"
import {
  LinearProgress,
  Typography,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Chip,
} from "@material-ui/core"
import { getShootDetails } from "../../actions/shoots"
import { isEmpty, remove } from "lodash"

import styles from "./styles"
import { getUser, toggleProfileDialog } from "../../actions/users"
import CrewCard from "../../components/CrewCard"
import { StaticGoogleMap, Marker } from "react-static-google-map"
import PlaceIcon from "@material-ui/icons/Place"
import moment from "moment"
import PositionChip from "../../components/ProfileDialog/PositionChip"
import { connect } from "react-redux"
import { hash } from "rsvp"
import MainAppBar from "../../components/MainAppBar/index"
import TabBar from "../../components/TabBar/index"
import { formatMoney } from "accounting"
import CrewMamaAppBarComponent from "../../components/CrewmamaAppBar"
import { getCurrentHost } from "../../utils/getHost"
import DownloadPdfButton from "../../components/Billing/Common/DownloadPdfButton/index"
import { Box } from "../../../node_modules/@material-ui/core/index"
import { useSelector } from "react-redux"
import { getEquipment, getRoles, getUsers } from "../../actions/misc"
import { getClientCompanies, getClientList } from "../../actions/clients"
import {
  updateShoot,
  deleteShoot,
  getShootbyId,
  createShootGlue,
  deleteShootGlue,
  setRoleForCrew,
  toggleRoleDialog,
  toggleShootDialog,
  toggleChangeRepresentativeDialog,
  recallShoot,
} from "../../actions/shoots"
import { clearCrewFromChip, getCrew } from "../../actions/crew"
import { getDealMemoData } from "../../actions/billing"

const locationVal = e => (e ? e + " " : "")

class Three extends Component {
  state = {
    shootDetails: {},
    userData: {},
    expenseData: [],
  }
  componentDidMount() {
    this.props
      .dispatch(getShootDetails(this.props.location.pathname.match(/(\d+)/)[0]))
      .then(shootRes => {
        // console.log('shootRes', shootRes);
        let promises = {}
        // Load Created by data
        promises["createdBy"] = this.props.dispatch(
          getUser(shootRes.creator_id)
        )

        // Load Client Data
        if (shootRes.client_id) {
          promises["client"] = this.props.dispatch(getUser(shootRes.client_id))
        }

        // Load Producer Data
        if (shootRes.producer) {
          promises["producer"] = this.props.dispatch(getUser(shootRes.producer))
        }

        // Load role user data
        const rolesWithUsers = shootRes.roles.filter(role => {
          // return roles where there is a user_id
          return role.user_id
        })
        // splice out role with name "PRODUCER" if it's user_id is the same as shootRes.producer
        remove(shootRes.roles, role => {
          return (
            role.name === "PRODUCER" &&
            role.user_id === parseInt(shootRes.producer, 10)
          )
        })
        if (rolesWithUsers.length > 0) {
          promises["roleUsers"] = Promise.all(
            rolesWithUsers.map(role =>
              this.props.dispatch(getUser(role.user_id))
            )
          )
        }

        hash(promises)
          .then(data => {
            const {
              createdBy: created_by = {},
              client = {},
              producer = {},
              roleUsers = [],
            } = data

            this.setState({
              shootDetails: {
                ...shootRes,
                created_by,
                client,
                producer,
                roles: shootRes.roles.map(role => {
                  const roleUser = roleUsers.find(
                    user => user.id === role.user_id
                  )
                  if (roleUser) {
                    role = {
                      ...role,
                      user: roleUser,
                    }
                  }
                  return role
                }),
              },
            })
            this.setState({
              expenseData: this.props.users
                .filter((position, i) => {
                  // console.log('position', position);
                  if (this.props.authenticatedUser.id === position.user_id) {
                    console.log(
                      `${position.first_name} is allowed to download the file`
                    )
                    return position
                  } else {
                    console.log(
                      "You do not have the rights to download the PDF"
                    )
                  }
                })
                .pop(),
            })

            this.callComponentMount()
          })
          .catch(err => {
            console.log(err)
          })
      })
  }

  callComponentMount = () => {
    let shootId = window.location.pathname.match(/\d+/g).map(Number)

    this.props.users.length === 1 && this.props.dispatch(getUsers())
    // this.props.roles.length === 1 && this.props.dispatch(getRoles())
    // this.props.equipment.length === 1 && this.props.dispatch(getEquipment())
    // this.props.companyList.length === 0 &&
    //   this.props.dispatch(getClientCompanies())
    // this.props.clientList.length === 0 && this.props.dispatch(getClientList())

    this.props
      .dispatch(getShootDetails(shootId))
      .then(() => {
        this.state.shootDetails.roles.forEach(role => {
          if (role.user_id) {
            this.props.dispatch(getCrew(role.user_id))
          }
        })
        this.state.shootDetails.shoots.forEach(applicant => {
          if (applicant.id) {
            this.props.dispatch(getCrew(applicant.user_id))
          }
        })
      })
      .catch(error => console.log("error", error))

    this.props.dispatch(getDealMemoData(shootId))
    this.props.dispatch(recallShoot(false))
  }

  // componentDidCatch = () => {
  //   this.setState({expenseData: this.props.users.filter((position, i) => {
  //     requestAnimationFrame()
  //     console.log('position', position);
  //     if(this.props.authenticatedUser.id === position.user_id){
  //       console.log(`${position.first_name} is allowed to download the file`)
  //       debugger;
  //       return position.expenses[i];
  //     }
  //     else {
  //       console.log('You do not have the rights to download the PDF')
  //     }
  //   })})
  // }

  // expenseCalc = () => {
  //   this.props.users.map(position => {
  //     console.log('position', position);
  //     if(props.authenticatedUser.id === position.user_id){
  //       console.log(`${position.first_name} is allowed to download the file`)
  //       return position;
  //     }
  //     else {
  //       console.log('You do not have the rights to download the PDF')
  //     }
  //   })
  // }

  render() {
    const { props, state } = this
    const { classes } = props
    const { shootDetails } = state

    // console.log('shoot details', shootDetails);
    // console.log('this', this);
    // console.log('user data', this.props.userData);
    // console.log('inside of call sheet')
    // console.log('expense data', state.expenseData);
    // debugger
    let isAd = false
    this.props.authenticatedUser.companies.map(company => {
      if (company.name === "Assignment Desk") {
        company.managers.map(manager => {
          if (manager.id === this.props.authenticatedUser.id) {
            isAd = true
          }
        })
      }
    })
    let isRole = false
    if (!isEmpty(state.shootDetails)) {
      state.shootDetails.roles.map(role => {
        if (role.user_id === this.props.authenticatedUser.id) {
          isRole = true
        }
      })
      if (
        this.state.shootDetails.creator_id !==
          this.props.authenticatedUser.id &&
        isAd === false &&
        isRole === false
      ) {
        this.props.history.push(`/crew`)
      } else if (isRole && isAd === false) {
        console.log("You are allowed to view this shoot")
        // this.props.history.push(`/public/shoots/${this.state.shoot.id}`)
        // this.props.history.push(`/my-shoots/${this.state.shoot.id}/details`)
      } else {
        console.log("You are allowed to view this shoot")
      }
    }

    // ONLY SHOOT OWNERS AND AD MEMBERS SHOULD BE ABLE TO VIEW THE EDIT SHOOT PAGES
    // Crew members should be redirected to the public shoot details page
    // There is already logic to direct crew members to the details page but this is just
    // in case they type the URL directly

    const generalData = shootDetails

    // const newArray = shootDetails.roles && shootDetails.roles.map((user) => {
    //   debugger;
    //   // console.log('new user', user.user.email);
    //   if(user.user.id === user.user_id) {
    //     return user;
    //   }
    // })
    // console.log('newArray', newArray);

    // console.log('authenticatedUser', props.authenticatedUser)

    // this.setState({
    //   expenseData: this.props.users.filter((position, i) => {
    //     console.log('position', position);
    //     if(props.authenticatedUser.id === position.user_id){
    //       console.log(`${position.first_name} is allowed to download the file`)
    //       debugger;
    //       // return position.expenses[i];
    //       return position;
    //     }
    //     else {
    //       console.log('You do not have the rights to download the PDF')
    //     }
    //   }).pop(),
    // })

    return isEmpty(state.shootDetails) ? (
      <LinearProgress style={{ width: "100%" }} />
    ) : (
      !isEmpty(props.authenticatedUser) && (
        <div>
          {getCurrentHost() === "crewmama" ? (
            <CrewMamaAppBarComponent history={this.props.history} />
          ) : (
            <Fragment>
              <MainAppBar />
              <TabBar history={this.props.history} showDivider />
            </Fragment>
          )}

          <div style={{ margin: "16px" }}>
            <Grid container spacing={2}>
              <Grid item lg={7}>
                <Card style={{ textAlign: "left" }}>
                  <CardHeader
                    titleTypographyProps={{ variant: "h4" }}
                    title={shootDetails.name}
                  />
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item lg={6}>
                        <div className={classes.detailWrapper}>
                          <Typography
                            className={classes.detailTypography}
                            variant="h5"
                          >
                            Booked By
                          </Typography>
                          <CrewCard
                            crew={shootDetails.created_by}
                            isPositionSearch={false}
                            currentUser={props.authenticatedUser}
                            bottomArea={e => {
                              return (
                                <div
                                  style={{
                                    alignSelf: "flex-start",
                                    marginTop: 8,
                                  }}
                                >
                                  <Typography
                                    gutterBottom
                                    variant="caption"
                                    className={classes.phone}
                                  >
                                    <a
                                      href={`tel:${
                                        shootDetails.created_by.phone
                                      }`}
                                    >
                                      {shootDetails.created_by.formattedPhone}
                                    </a>
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    className={classes.extraLineTypography}
                                  >
                                    <a
                                      href={`mailto:${
                                        shootDetails.created_by.email
                                      }`}
                                    >
                                      {shootDetails.created_by.email}
                                    </a>
                                  </Typography>
                                </div>
                              )
                            }}
                            onOpenProfile={() =>
                              this.props.dispatch(
                                toggleProfileDialog(true, {
                                  id: shootDetails.creator_id,
                                })
                              )
                            }
                            hideRating
                          />
                        </div>
                        {!isEmpty(shootDetails.client) && (
                          <div className={classes.detailWrapper}>
                            <Typography
                              className={classes.detailTypography}
                              variant="h5"
                            >
                              Client
                            </Typography>
                            <Typography>
                              {shootDetails.client.first_name}{" "}
                              {shootDetails.client.last_name}
                              {shootDetails.client.organization ? " - " : ""}
                              {shootDetails.client.organization}
                            </Typography>
                          </div>
                        )}
                        {shootDetails.camera && (
                          <div className={classes.detailWrapper}>
                            <Typography
                              className={classes.detailTypography}
                              variant="h5"
                            >
                              Camera
                            </Typography>
                            <Typography>{shootDetails.camera}</Typography>
                          </div>
                        )}
                        {shootDetails.story && (
                          <div className={classes.detailWrapper}>
                            <Typography
                              className={classes.detailTypography}
                              variant="h5"
                            >
                              Story
                            </Typography>
                            <Typography>{shootDetails.story}</Typography>
                          </div>
                        )}
                        {shootDetails.format && (
                          <div className={classes.detailWrapper}>
                            <Typography
                              className={classes.detailTypography}
                              variant="h5"
                            >
                              Format
                            </Typography>
                            <Typography>{shootDetails.format}</Typography>
                          </div>
                        )}
                        {shootDetails.specs && (
                          <div className={classes.detailWrapper}>
                            <Typography
                              className={classes.detailTypography}
                              variant="h5"
                            >
                              Specs
                            </Typography>
                            <Typography>{shootDetails.specs}</Typography>
                          </div>
                        )}
                      </Grid>
                      <Grid item lg={6}>
                        <div className={classes.detailWrapper}>
                          <Typography
                            className={classes.detailTypography}
                            variant="h5"
                          >
                            Location
                          </Typography>
                          <StaticGoogleMap
                            className={classes.mapImage}
                            size="444x222"
                            center={`${shootDetails.location.lat},${
                              shootDetails.location.lon
                            }`}
                            zoom="13"
                            apiKey="AIzaSyBH1JVqWhWjVFovOypE3kxxHx4GmPnPDUY"
                          >
                            <Marker
                              location={`${shootDetails.location.lat},${
                                shootDetails.location.lon
                              }`}
                            />
                          </StaticGoogleMap>
                          <div className={classes.location}>
                            <PlaceIcon
                              className={this.props.classes.placeIcon}
                            />
                            <Typography
                              variant="caption"
                              className={this.props.classes.placeName}
                              color="inherit"
                            >
                              {`${locationVal(
                                shootDetails.location.street_number
                              )}${locationVal(
                                shootDetails.location.route
                              )}${locationVal(
                                shootDetails.location.city
                              ).replace(" ", ", ")}${locationVal(
                                shootDetails.location.state
                              )}${locationVal(
                                shootDetails.location.zip
                              ).replace(" ", "")}`}
                            </Typography>
                          </div>
                        </div>
                        <div className={classes.detailWrapper}>
                          <Typography
                            className={classes.detailTypography}
                            variant="h5"
                          >
                            {shootDetails.full_day
                              ? "Full Day Shoot"
                              : "Half Day Shoot"}
                          </Typography>
                          <Typography>
                            {moment(shootDetails.start_date).format(
                              "MMM DD, YYYY"
                            )}
                            {shootDetails.full_day
                              ? " - Full Day"
                              : ` - ${moment(shootDetails.end_date).format(
                                  "MMM DD, YYYY"
                                )}`}
                          </Typography>
                          <Typography>
                            {moment(
                              `10-21-2015 ${shootDetails.call_time}`
                            ).format("hh:mm A")}
                            {" - "}
                            {shootDetails.timezone}
                          </Typography>
                          {this.props.users.map(position => {
                            if (
                              props.authenticatedUser.id === position.user_id
                            ) {
                              // console.log(`${position.first_name} is allowed to download the file`)
                              return (
                                <>
                                  <DownloadPdfButton
                                    type="deal-memo"
                                    data={
                                      {
                                        shoot_name: this.props.userData.name,
                                        ...this.props.users
                                          .filter((position, i) => {
                                            if (
                                              props.authenticatedUser.id ===
                                              position.user_id
                                            ) {
                                              // console.log(`${position.first_name} is allowed to download the file`)
                                              // debugger;
                                              // return position.expenses[i];
                                              return position
                                            } else {
                                              // console.log('You do not have the rights to download the PDF')
                                            }
                                          })
                                          .pop(),
                                      }
                                      /* THESE MAP FUNCTIONS GO THROUGH ALL OF THE CREW MEMBERS ON A SHOOT
                                    AND RETURN AN ARRAY FILLED WITH DATA FOR THE LOGGED IN USER,
                                    AND UNDEFINED ARRAYS FOR THE OTHER USERS. WE WANT TO ONLY KEEP ONE
                                    ARRAY WHICH FILLED WITH THE CORRECT DATA SO WE SLICE ALL BUT THE FIRST ELEMENT
                                    MAKE SURE TO TEST WITH MORE THAN 2 CREW MEMBERS */
                                      // shoot_name: generalData && generalData.name,
                                      // company_id: generalData && generalData.id,
                                      // crewmama_or_gtt: generalData && generalData.crewmama_or_gtt,
                                      // company_logo_image: null,
                                      // start_date: generalData && generalData.start_date,
                                      // end_date: generalData && generalData.end_date,

                                      // first_name:[...this.props.users &&
                                      //   this.props.users.map(position => {
                                      //     console.log('position', position);
                                      //     if(props.authenticatedUser.id === position.user_id){
                                      //       console.log(`${position.first_name} is allowed to download the file`)
                                      //       return position.first_name;
                                      //     }
                                      //     else {
                                      //       console.log('You do not have the rights to download the PDF')
                                      //     }
                                      //   })].splice(1).slice(0, 1),

                                      //   last_name:[...this.props.users &&
                                      //     this.props.users.map(position => {
                                      //       console.log('position', position);
                                      //       if(props.authenticatedUser.id === position.user_id){
                                      //         console.log(`${position.first_name} is allowed to download the file`)
                                      //         return position.last_name;
                                      //       }
                                      //       else {
                                      //         console.log('You do not have the rights to download the PDF')
                                      //       }
                                      //     })].splice(1).slice(0, 1),

                                      //     name:[...this.props.users &&
                                      //       this.props.users.map(position => {
                                      //         console.log('position', position);
                                      //         if(props.authenticatedUser.id === position.user_id){
                                      //           console.log(`${position.first_name} is allowed to download the file`)
                                      //           return position.name;
                                      //         }
                                      //         else {
                                      //           console.log('You do not have the rights to download the PDF')
                                      //         }
                                      //       })].splice(1).slice(0, 1),

                                      // shoot_id: shootDetails.id && shootDetails.id,
                                    }
                                  />
                                  <Box marginRight="10px" marginTop="10px" />
                                </>
                              )
                            } else {
                              console.log(
                                "You do not have the rights to download the PDF"
                              )
                            }
                          })}
                        </div>
                        {shootDetails.equipment.length > 0 && (
                          <div className={classes.detailWrapper}>
                            <Typography
                              className={classes.detailTypography}
                              variant="h5"
                            >
                              Equipment
                            </Typography>
                            {shootDetails.equipment.map(equipment => (
                              <PositionChip
                                key={equipment.id}
                                position={equipment.name}
                                canRemove={false}
                              />
                            ))}
                          </div>
                        )}
                        {shootDetails.forward_facing_text && (
                          <div className={classes.detailWrapper}>
                            <Typography
                              className={classes.detailTypography}
                              variant="h5"
                            >
                              Description
                            </Typography>
                            <Typography>
                              {shootDetails.forward_facing_text}
                            </Typography>
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={12} lg={5}>
                <Card style={{ textAlign: "left" }}>
                  <CardHeader
                    titleTypographyProps={{ variant: "h4" }}
                    title="Crew Members"
                  />
                  <CardContent>
                    {shootDetails.roles.length === 0 && (
                      <Typography variant="h6">
                        No Crew Members have been assigned yet
                      </Typography>
                    )}
                    {typeof shootDetails.producer === "object" &&
                      !isEmpty(shootDetails.producer) && (
                        <div className={classes.card}>
                          <CrewCard
                            crew={shootDetails.producer}
                            isPositionSearch={false}
                            currentUser={props.authenticatedUser}
                            bottomArea={e => {
                              return (
                                <div
                                  style={{
                                    alignSelf: "flex-start",
                                    marginTop: 8,
                                  }}
                                >
                                  <Typography
                                    gutterBottom
                                    variant="caption"
                                    className={classes.phone}
                                  >
                                    <a
                                      href={`tel:${
                                        shootDetails.producer.phone
                                      }`}
                                    >
                                      {shootDetails.producer.formattedPhone}
                                    </a>
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    className={classes.extraLineTypography}
                                  >
                                    <a
                                      href={`mailto:${
                                        shootDetails.producer.email
                                      }`}
                                    >
                                      {shootDetails.producer.email}
                                    </a>
                                  </Typography>
                                </div>
                              )
                            }}
                            topArea={e => {
                              return (
                                <div
                                  style={{
                                    position: "absolute",
                                    zIndex: 1,
                                    margin: "8px",
                                  }}
                                >
                                  <Chip
                                    label="PRODUCER"
                                    color="primary"
                                    style={{ color: "white" }}
                                  />
                                </div>
                              )
                            }}
                            onOpenProfile={() =>
                              this.props.dispatch(
                                toggleProfileDialog(true, {
                                  id: shootDetails.producer.id,
                                })
                              )
                            }
                            hideRating
                          />
                        </div>
                      )}
                    {shootDetails.roles.length > 0 &&
                      shootDetails.roles.map((role, i) => (
                        <Fragment key={i}>
                          {role.hasOwnProperty("user") ? (
                            // role.requested &&
                            // role.available ?
                            <div key={role.id} className={classes.card}>
                              <CrewCard
                                crew={role.user}
                                isPositionSearch={false}
                                currentUser={props.authenticatedUser}
                                bottomArea={e => {
                                  return (
                                    <div
                                      style={{
                                        alignSelf: "flex-start",
                                        marginTop: 8,
                                      }}
                                    >
                                      <Typography
                                        gutterBottom
                                        variant="caption"
                                        className={classes.phone}
                                      >
                                        <a href={`tel:${role.user.phone}`}>
                                          {role.user.formattedPhone}
                                        </a>
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        className={classes.extraLineTypography}
                                      >
                                        <a href={`mailto:${role.user.email}`}>
                                          {role.user.email}
                                        </a>
                                      </Typography>
                                      {this.props.authenticatedUser.id ===
                                        role.user.id && (
                                        <div
                                          className={classes.rateWrapper}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <Typography
                                              variant="p"
                                              className={classes.rateHeadline}
                                            >
                                              Rate
                                            </Typography>
                                            <Typography
                                              variant="p"
                                              className={classes.rate}
                                            >
                                              {formatMoney(
                                                role.crew_rate,
                                                "$",
                                                0
                                              )}
                                            </Typography>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )
                                }}
                                topArea={e => {
                                  return (
                                    <div
                                      style={{
                                        position: "absolute",
                                        zIndex: 1,
                                        margin: "8px",
                                      }}
                                    >
                                      <Chip
                                        label={role.name}
                                        color="primary"
                                        style={{ color: "white" }}
                                      />
                                    </div>
                                  )
                                }}
                                onOpenProfile={() =>
                                  this.props.dispatch(
                                    toggleProfileDialog(true, {
                                      id: role.user.id,
                                    })
                                  )
                                }
                                hideRating
                              />
                            </div>
                          ) : (
                            <Card
                              className={classes.card}
                              style={{ maxWidth: "300px" }}
                            >
                              <CardContent>
                                <Typography>
                                  {role.name}
                                  {" - UNFILLED"}
                                </Typography>
                              </CardContent>
                            </Card>
                          )}
                        </Fragment>
                      ))}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        </div>
      )
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    activeCompany: state.companies.activeCompany,
    userData: state.billing.generalData,
    // Wrong below that's ALL users
    // users: state.misc.users,
    roles: state.misc.roles,
    users: state.billing.usersRolesArray,
    crew: state.crew,
  }
}

Three.propTypes = {
  position: PropTypes.object,
  expenseData: PropTypes.array,
}

const connector = connect(mapStateToProps)

export default compose(withStyles(styles))(connector(Three))
